const currencyFormatter = (inputValue: number, currency: string = 'USD'): string => {
  return Intl.NumberFormat('en-US', {style: 'currency', currency: currency}).format(inputValue);
}

export default currencyFormatter;